import { Heading2 } from "@/components/podkit/typography/Headings";
import type { FC } from "react";
import { ServiceAccountSecretsList } from "@/components/settings/organization/service-accounts/ServiceAccountSecretsList";
import { useCreateServiceAccountAccessToken, useGetServiceAccount } from "@/queries/service-account-queries";
import { ErrorMessage } from "@/components/ErrorMessage";
import { serviceAccountHeaders } from "@/api";
import { useFlagServiceAccountSecretsManagementEnabled } from "@/hooks/use-flag";

export const ServiceAccountSecrets: FC<{ serviceAccountId: string }> = ({ serviceAccountId }) => {
    const { value: isEnabled, loading: isFlagLoading } = useFlagServiceAccountSecretsManagementEnabled();

    const { data: serviceAccount, error: getServiceAccountError } = useGetServiceAccount({ serviceAccountId });

    // The service account access token is created using the logged in identity
    const { data: serviceAccountAccessToken, error: serviceAccountAccessTokenError } =
        useCreateServiceAccountAccessToken({ serviceAccountId, enabled: isEnabled });

    // These headers can be used to perform requests on behalf of the service account
    const headers =
        serviceAccountAccessToken && serviceAccount
            ? serviceAccountHeaders({ serviceAccountId, serviceAccountAccessToken: serviceAccountAccessToken })
            : undefined;

    // Don't render if feature flag is disabled or still loading
    if (isFlagLoading || !isEnabled) {
        return null;
    }

    return (
        <div className="flex flex-col gap-2">
            <div className="flex min-h-7 flex-grow items-center justify-between gap-2">
                <Heading2 className="text-lg font-medium">Secrets</Heading2>
            </div>
            <ErrorMessage error={getServiceAccountError} />
            <ErrorMessage error={serviceAccountAccessTokenError} />
            <ServiceAccountSecretsList headers={headers} serviceAccountId={serviceAccountId} />
        </div>
    );
};
